import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';

import { Color, ColorPickerControl } from '@iplab/ngx-color-picker';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ColorPickerService } from '../color-picker.service';

export interface ColorDefinition {
    tagValue: string;
    value: number;
}

/**
 * This component let us to select a color in RGB format
 */
@Component({
    templateUrl: './chrome-picker-selector.component.html',
    styleUrls: ['./chrome-picker-selector.component.scss'],
    standalone: false,
})
export class ChromePickerSelectorComponent implements OnInit, OnDestroy {
    sketchControl: ColorPickerControl = new ColorPickerControl();
    /** This property is set when the popup is opened*/
    colorData = '';
    /** This property is set when the popup is opened*/
    idColorPicker = '';

    hexadecimalValue = '';

    private colorPickerControl: ColorPickerControl = new ColorPickerControl();
    private color: Color = new Color();
    private valueChangesSubscription: Subscription | undefined;

    constructor(private colorPickerService: ColorPickerService) {}

    ngOnInit(): void {
        this.sketchControl = this.colorPickerControl.hideAlphaChannel();
        this.valueChangesSubscription = this.sketchControl.valueChanges.pipe(debounceTime(16)).subscribe((value: Color) => {
            this.color = value;
            this.hexadecimalValue = this.color.toHexString();
        });
    }

    ngOnDestroy(): void {
        this.valueChangesSubscription?.unsubscribe();
    }

    /** @ignore */
    @HostBinding('style.background-color')
    background(): string {
        return this.sketchControl.value.toHexString();
    }

    /** @ignore */
    sendRGBColor(): void {
        const color: ColorDefinition[] = [
            { tagValue: 'R', value: Math.round(this.color.getRgba().red) },
            { tagValue: 'G', value: Math.round(this.color.getRgba().green) },
            { tagValue: 'B', value: Math.round(this.color.getRgba().blue) },
        ];
        this.colorPickerService.setActualColorValue(this.idColorPicker, color);
    }

    /** @ignore */
    cancel(): void {
        this.colorPickerService.setActualColorValue(this.idColorPicker, null);
    }
}
